import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from './client'
import { queryKeys } from './keys'

/*
 * Base query hooks shared by every area. Organizer hooks: api/organizer.ts. Member + public hooks: api/member.ts.
 * Pattern: one hook per route, keys from queryKeys, invalidate on mutation success. SHARED, FROZEN after Phase 0.
 */

export const useHealth = () => useQuery({ queryKey: queryKeys.health, queryFn: () => api('health') })

export const usePublicConfig = () =>
  useQuery({ queryKey: queryKeys.publicConfig, queryFn: () => api('publicConfig'), staleTime: Infinity })

// retryOnMount: false — without data, a refetch flips the query back to `pending`; since RequireOrganizer
// unmounts its children while pending and those children observe this query too, an errored query would
// otherwise loop (mount → refetch → pending → unmount → error → mount …).
export const useOrgMe = () =>
  useQuery({
    queryKey: queryKeys.org.me,
    queryFn: () => api('orgMe'),
    retry: false,
    retryOnMount: false,
    staleTime: 60_000,
  })

export const useOrgLogout = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => api('orgLogout'),
    onSuccess: () => qc.removeQueries({ queryKey: ['org'] }),
  })
}
